import React from 'react';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Send from '@material-ui/icons/Send';
import TextField from '@material-ui/core/TextField';

export default function CommentForm(props) {
  const [disabled, setDisabled] = React.useState(true);
  const [bodyData, setBodyData] = React.useState({
    creator: '',
    text: '',
    threadId: props.threadId,
    reply: 0,
  });
  const [postError, setPostError] = React.useState({
    error: false,
    status: null,
    statusText: ''
  });

  React.useEffect(() => {
    if (bodyData.creator && bodyData.text) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [bodyData]);

  const postData = () => {
    if (bodyData.text && bodyData.creator) {
      axios.post("/keijiban/contents", bodyData)
        .then(res => (res.status == 201) && window.location.reload())
        .catch(err => setPostError({error: true, status: err.response.status, statusText: err.response.statusText}));
    }
  };

  return (
    <Paper>
      <Box p={1}>
      <TextField
        required
        margin='dense'
        id='name'
        label='お名前'
        variant='outlined'
        onChange={e => setBodyData({...bodyData, creator: e.target.value})}
      />
      <TextField
        required
        margin='dense'
        id='comment'
        label='コメント'
        multiline
        rows={3}
        fullWidth
        variant='outlined'
        onChange={e => setBodyData({...bodyData, text: e.target.value})}
      />
      <Typography variant='body1' color='error'>
        {postError.error && `サーバーへの送信に失敗しました ${postError.status} (${postError.statusText})`}
      </Typography>
      <Button
        variant='contained'
        color='primary'
        endIcon={<Send />}
        fullWidth
        disabled={disabled}
        onClick={() => postData()}
      >
        送信
      </Button>
      </Box>
    </Paper>
  );
}
